import { inject, Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';

import { Observable } from 'rxjs';
import { CONFIG } from '../../../../config.token';

@Injectable()
export class BaseUrlInterceptor implements HttpInterceptor {

  private config = inject(CONFIG);

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        let newRequest = request;
        if (!request.url.startsWith('http')) {
            newRequest = request.clone({ url: `${this.config.API_URL}${request.url}` });
        }

        return next.handle(newRequest);
    }
}
